import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import NewsPage from "@/pages/NewsPage";

export const Route = createFileRoute("/news")({
  head: () => pageHead("AI News & Insights", "Curated AI news for enterprise and government covering research breakthroughs, technical deep-dives, and industry trends.", "/news", false),
  component: NewsPage,
});
